'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var deviceProfiler = require('@narvar/device-profiler');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var deviceProfiler__default = /*#__PURE__*/_interopDefaultLegacy(deviceProfiler);

const DeviceProfileContext = /*#__PURE__*/React.createContext(null);
const useDeviceProfile = () => {
  const context = React.useContext(DeviceProfileContext);
  if (!context) {
    throw new Error('No context provided for DeviceProfile provider');
  }
  return context;
};
const DeviceProfileProvider = _ref => {
  let {
    children
  } = _ref;
  const [deviceProfile, setDeviceProfile] = React.useState(null);
  React.useEffect(() => {
    const getDeviceProfile = async () => {
      const {
        browser_fingerprint,
        device_size_px
      } = await deviceProfiler__default["default"];
      setDeviceProfile({
        browserFingerprint: browser_fingerprint,
        deviceSizePx: device_size_px
      });
    };
    getDeviceProfile().catch(() => {});
  }, []);
  if (!deviceProfile) return null;
  return /*#__PURE__*/React__default["default"].createElement(DeviceProfileContext.Provider, {
    value: deviceProfile
  }, children);
};

exports.DeviceProfileContext = DeviceProfileContext;
exports.DeviceProfileProvider = DeviceProfileProvider;
exports.useDeviceProfile = useDeviceProfile;
